import React from "react";
import { FaMapMarkedAlt } from "react-icons/fa";
import { FiMapPin } from "react-icons/fi";

import { cn, toAbsolute } from "./groupPlanningUtils";

const FALLBACK = "/img/no-image.jpg";

export default function DojoInfoCard({
  dojo,
  mapUrl,
  showMap,
  onToggleMap,
  onOpenPhoto,
}) {
  if (!dojo) return null;

  return (
    <div className="mx-auto mt-10 max-w-5xl overflow-hidden rounded-[2.5rem] border border-slate-200 bg-white/90 shadow-xl backdrop-blur-xl dark:border-white/10 dark:bg-slate-900/80">
      <div className="grid md:grid-cols-[0.85fr_1.15fr]">
        <button
          type="button"
          onClick={onOpenPhoto}
          className="group relative block min-h-[260px] overflow-hidden text-left md:min-h-full"
          aria-label="Agrandir la photo du dojo"
        >
          <img
            src={toAbsolute(dojo.dojo_photoURL) || FALLBACK}
            alt={dojo.dojo_nom}
            className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
            loading="lazy"
            onError={(event) => {
              event.currentTarget.src = FALLBACK;
            }}
          />

          <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-slate-950/10 to-transparent" />

          <div className="absolute bottom-5 left-5 right-5">
            <span className="inline-flex rounded-full border border-white/20 bg-white/15 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-white backdrop-blur-xl">
              Voir la photo
            </span>
          </div>
        </button>

        <div className="relative p-6 sm:p-8">
          <div className="absolute -right-16 -top-16 h-44 w-44 rounded-full bg-primary/10 blur-3xl" />

          <div className="relative">
            <div className="inline-flex items-center gap-2 rounded-full border border-orange-200 bg-orange-50 px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-orange-700 dark:border-orange-500/20 dark:bg-orange-500/10 dark:text-orange-300">
              <FaMapMarkedAlt />
              Lieu de pratique
            </div>

            <h3 className="mt-5 font-barlow text-3xl font-extrabold text-slate-950 dark:text-white">
              {dojo.dojo_nom}
            </h3>

            {dojo.dojo_discipline && (
              <p className="mt-2 text-sm font-semibold text-slate-500 dark:text-slate-400">
                {dojo.dojo_discipline}
              </p>
            )}

            {dojo.dojo_adresse && (
              <p className="mt-5 flex items-start gap-3 text-sm leading-7 text-slate-600 dark:text-slate-300">
                <FiMapPin className="mt-1 shrink-0 text-primary" />
                <span>{dojo.dojo_adresse}</span>
              </p>
            )}

            {mapUrl && (
              <button
                type="button"
                onClick={onToggleMap}
                className="mt-6 inline-flex items-center justify-center rounded-full border border-primary/20 bg-primary/10 px-5 py-3 text-sm font-bold text-primary transition hover:-translate-y-0.5 hover:bg-primary hover:text-white"
              >
                {showMap ? "Masquer la carte" : "Afficher la carte"}
              </button>
            )}

            {showMap && mapUrl && (
              <div className="mt-6 overflow-hidden rounded-3xl border border-slate-200 dark:border-white/10">
                <iframe
                  title={`Map ${dojo.dojo_nom}`}
                  src={mapUrl}
                  width="100%"
                  height="240"
                  className={cn("block w-full")}
                  loading="lazy"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}